import React from 'react';
import { IA_KEY } from 'helpers/ia-logic';
import { NAV_KEY } from 'constants/venue-experience';

import { FlyoutProvider } from 'components/Flyout/FlyoutContext';
import { handleRouteEnter, watchActions } from './SmartTools.saga';
import SmartToolsV2 from './SmartToolsV2';
import { SmartToolsContextProvider } from './SmartToolsContext';
import { ClassLevelMinimumSpotsContextProvider } from './Contexts/ClassLevelMinimumSpotsContext';

const SmartToolsV2WithProvider = () => (
  <FlyoutProvider>
    <SmartToolsContextProvider>
      <ClassLevelMinimumSpotsContextProvider>
        <SmartToolsV2 />
      </ClassLevelMinimumSpotsContextProvider>
    </SmartToolsContextProvider>
  </FlyoutProvider>
);

export default [
  {
    path: '/manage/:venueId/smarttools',
    iaKey: IA_KEY.SMART_SPOT,
    navKey: NAV_KEY.SMART_SPOT,
    pathSagas: [watchActions],
    locationSagas: [handleRouteEnter],
    component: SmartToolsV2WithProvider,
  },
];
